import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'dragFile': true,
        'uploadProps': {
            accept: 'image/*',
            limit: 5,
        },
        'ev-uploadError': this.onUploadError,
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value'),
        'ev-$model:attachments': function($v) {
            $this.set('attachments', $v);
        },
        'attachments': $this.get('attachments')
    });
};